module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "side-bar",
    class: _vm.getClass
  }, [_c('div', {
    staticClass: "side-bar_block side-bar_header"
  }, [_c('p', {
    staticClass: "left_block menuText"
  }, [_vm._v("МЕНЮ")]), _c('AppSvgIcon', {
    staticClass: "right_block close_button",
    attrs: {
      "icon-name": _vm.$ui.IconSvgName.close
    },
    on: {
      "click": _vm.closeThis
    }
  })], 1), _c('ul', _vm._l((_vm.data), function(elem, index) {
    return _c('li', {
      key: index,
      staticClass: "side-bar_block",
      on: {
        "click": function($event) {
          return _vm.clickElement(elem.route)
        }
      }
    }, [_c('p', {
      staticClass: "left_block menuText button_link"
    }, [_vm._v(_vm._s(elem.text))]), (!!elem.count) ? _c('p', {
      staticClass: "right_block"
    }, [_vm._v(_vm._s(elem.count))]) : _vm._e()])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bcb6737","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppDefaultLayout/components/sections/navSidebar/NavSidebar.vue
// module id = e69f6e2c19f30ee3e402
// module chunks = 0